// Component
export default () => {
    const sections = document.querySelectorAll('.content-cards')
    const breakpoint = 992

    // If there are no sections, return
    if (!sections)
        return

    const updHeight = (items, height) => {
        items.forEach(footer => {
            footer.style.height = height
                ? `${height}px`
                : null
        })
    }

    const getHeight = () => {
        sections.forEach(section => {
            const footers = Array.from(section
                .querySelectorAll('.content-card-style-card .content-card-footer')
            )

            if (footers.length < 2)
                return

            updHeight(footers, 0)

            if (window.innerWidth >= breakpoint) {
                const heights = footers.map(footer => footer.offsetHeight)

                const uniqueHeights = Array.from(new Set(heights))

                if (uniqueHeights.length > 1)
                    updHeight(footers, Math.max(...uniqueHeights))
            }
        })
    }

    getHeight()

    window.addEventListener('resize',
        () => getHeight()
    )
}
